// Default network design configurations and templates

export const defaultNodeTypes = [
  { label: "Supplier", type: "supplier", color: "#4672c3", shape: "circle" },
  {
    label: "Overseas Consolidation",
    type: "consolidation",
    color: "#4672c3",
    shape: "circle",
  },
  {
    label: "US Warehouse",
    type: "warehouse",
    color: "#4672c3",
    shape: "circle",
  },
  { label: "Consumer", type: "consumer", color: "#4672c3", shape: "circle" },
];

export const defaultLocationTypes = [
  { label: "CN/IN", type: "location", color: "#70ac46", shape: "circle" },
  { label: "HK/IN", type: "location", color: "#70ac46", shape: "circle" },
  { label: "NJ/IL/CA", type: "location", color: "#70ac46", shape: "circle" },
  { label: "US", type: "location", color: "#70ac46", shape: "circle" },
];

export const defaultProcesses = [
  {
    label: "P.O. to suppliers",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Manufacture products",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Receive products and stock-in",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Bulk orders for each warehouse",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Pick, pack, and ship (Air or Ocean)",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Inbound receipt and stock-in",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  {
    label: "Fulfill individual consumer orders",
    type: "process",
    color: "#4672c3",
    shape: "box",
  },
  { label: "Buy/Order", type: "process", color: "#4672c3", shape: "box" },
];

// Template based on the provided image
export const supplyChainTemplate = {
  name: "Supply Chain Network Flow",
  description: "Complete supply chain network from supplier to consumer",
  nodes: [
    // Column 0 - Actors and Locations
    {
      id: "supplier",
      label: "Supplier",
      type: "supplier",
      column: 0,
      row: 0,
      color: "#4672c3",
      shape: "circle",
      parentId: null,
    },
    {
      id: "cn_in",
      label: "CN/IN",
      type: "location",
      column: 1,
      row: 0,
      color: "#70ac46",
      shape: "circle",
      parentId: null,
    },

    {
      id: "consolidation",
      label: "Overseas Consolidation",
      type: "consolidation",
      column: 0,
      row: 1,
      color: "#4672c3",
      shape: "circle",
      parentId: null,
    },
    {
      id: "hk_in",
      label: "HK/IN",
      type: "location",
      column: 1,
      row: 1,
      color: "#70ac46",
      shape: "circle",
      parentId: null,
    },

    {
      id: "us_warehouse",
      label: "US Warehouse",
      type: "warehouse",
      column: 0,
      row: 2,
      color: "#4672c3",
      shape: "circle",
      parentId: null,
    },
    {
      id: "nj_il_ca",
      label: "NJ/IL/CA",
      type: "location",
      column: 1,
      row: 2,
      color: "#70ac46",
      shape: "circle",
      parentId: null,
    },

    {
      id: "consumer",
      label: "Consumer",
      type: "consumer",
      column: 0,
      row: 3,
      color: "#4672c3",
      shape: "circle",
      parentId: null,
    },
    {
      id: "us",
      label: "US",
      type: "location",
      column: 1,
      row: 3,
      color: "#70ac46",
      shape: "circle",
      parentId: null,
    },

    // Column 2 - First Process
    {
      id: "po_suppliers",
      label: "P.O. to suppliers",
      type: "process",
      column: 2,
      row: 0,
      color: "#4672c3",
      shape: "box",
      parentId: "supplier",
    },

    // Column 2 - Manufacturing
    {
      id: "manufacture",
      label: "Manufacture products",
      type: "process",
      column: 3,
      row: 0,
      color: "#4672c3",
      shape: "box",
      parentId: "po_suppliers",
    },

    // Column 3 - Receiving
    {
      id: "receive_stock",
      label: "Receive products and stock-in",
      type: "process",
      column: 3,
      row: 1,
      color: "#4672c3",
      shape: "box",
      parentId: "manufacture",
    },
    {
      id: "bulk_orders",
      label: "Bulk orders for each warehouse",
      type: "process",
      column: 3,
      row: 2,
      color: "#4672c3",
      shape: "box",
      parentId: "consolidation",
    },
    {
      id: "buy_order",
      label: "Buy/Order",
      type: "process",
      column: 3,
      row: 3,
      color: "#4672c3",
      shape: "box",
      parentId: "consumer",
    },

    // Column 4 - Shipping
    {
      id: "pick_pack_ship",
      label: "Pick, pack, and ship (Air or Ocean)",
      type: "process",
      column: 4,
      row: 1,
      color: "#4672c3",
      shape: "box",
      parentId: "bulk_orders",
    },

    // Column 5 - Final fulfillment
    {
      id: "inbound_receipt",
      label: "Inbound receipt and stock-in",
      type: "process",
      column: 4,
      row: 2,
      color: "#4672c3",
      shape: "box",
      parentId: "pick_pack_ship",
    },
    {
      id: "fulfill_orders",
      label: "Fulfill individual consumer orders",
      type: "process",
      column: 5,
      row: 2,
      color: "#4672c3",
      shape: "box",
      parentId: "us_warehouse",
    },
  ],
  edges: [
    {
      id: "e1",
      from: "po_suppliers",
      to: "manufacture",
      arrows: "to",
      label: "",
    },
    {
      id: "e2",
      from: "manufacture",
      to: "receive_stock",
      arrows: "to",
      label: "",
    },
    {
      id: "e3",
      from: "receive_stock",
      to: "bulk_orders",
      arrows: "to",
      label: "",
    },
    // {
    //   id: "e4",
    //   from: "receive_stock",
    //   to: "pick_pack_ship",
    //   arrows: "to",
    //   label: "",
    // },
    {
      id: "e5",
      from: "bulk_orders",
      to: "pick_pack_ship",
      arrows: "to",
      label: "",
    },
    {
      id: "e6",
      from: "pick_pack_ship",
      to: "inbound_receipt",
      arrows: "to",
      label: "",
    },
    // {
    //   id: "e7",
    //   from: "inbound_receipt",
    //   to: "fulfill_orders",
    //   arrows: "to",
    //   label: "",
    // },
    {
      id: "e8",
      from: "buy_order",
      to: "fulfill_orders",
      arrows: "to",
      label: "",
    },
  ],
};
